import { render, staticRenderFns } from "./UiStep.vue?vue&type=template&id=8917e984&scoped=true"
import script from "./UiStep.vue?vue&type=script&lang=js"
export * from "./UiStep.vue?vue&type=script&lang=js"
import style0 from "./UiStep.vue?vue&type=style&index=0&id=8917e984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8917e984",
  null
  
)

export default component.exports